import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var SearchUserByPosCtrl = function (fn, er, pv, token, ids) {

    var config = {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json',
            'MT_SESSION_ID': ids
        },
    };
    var data = {
        codPointOfSales: pv
    }

    axios
        .post(ApiConfig.url.SEARCH_USER_POS_LIST, data, config)
        .then(function (result) {
            fn(result.data, result.status)
        })
        .catch(function (error) {
            er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
        });
}

export { SearchUserByPosCtrl };